export default "__VITE_ASSET__Cexyh1Le__"